/**
 * De twee dobbelstenen.
 *
 * Bron: kennisbank 02 §2.1 en 05 vraag 1. De gebeurtenissendobbelsteen heeft zes
 * vlakken waarvan er twee het vraagteken dragen; de andere vier gebeurtenissen staan
 * er elk één keer op.
 */
import { EVENT_DIE_FACES, type EventFace, type ProductionRoll } from '@catan/contracts';
import { pick, roll, type Rng } from './rng.js';

export interface DiceRoll {
  readonly event: EventFace;
  readonly production: ProductionRoll;
}

/** Gooit beide dobbelstenen; het resultaat geldt voor beide spelers. */
export function rollDice(rng: Rng): { rng: Rng; value: DiceRoll } {
  const eventStep = pick(rng, EVENT_DIE_FACES);
  const productionStep = roll(eventStep.rng, 6);
  return {
    rng: productionStep.rng,
    value: {
      event: eventStep.value,
      production: productionStep.value as ProductionRoll,
    },
  };
}
